import http from '@/utils/http';
import httpApi from '@/apis/httpApi';

// 获取员工管理列表
export const getEmplyeeTableList = ({ page, pageSize, search }) => {
  return http.usualPost({
    url: httpApi.emplyee.getTableList,
    data: {
      page,
      pageSize,
      search,
    },
  });
};
// 删除
export const _del = ({ passportName, smsCode }) => {
  return http.post({
    url: httpApi.emplyee.del,
    data: {
      passportName,
      smsCode,
    },
  });
};
// 状态
export const _status = ({ passportName, freezeState, smsCode }) => {
  return http.post({
    url: httpApi.emplyee.status,
    data: {
      passportName,
      freezeState,
      smsCode,
    },
  });
};
// 修改备注
export const _remark = ({ passportName, remark }) => {
  return http.post({
    url: httpApi.emplyee.mark,
    data: {
      passportName,
      remark,
    },
  });
};
// 注册子账号
export const registeredSubAccount = ({
  name,
  passportName,
  passportState,
  password,
  phone,
  email,
  passportType,
  pms1,
  pms10000,
  groupId,
  barId,
  smsCode,
}) => {
  return http.post({
    url: httpApi.emplyee.registerAdd,
    data: {
      name,
      passportName,
      passportState,
      password,
      phone,
      email,
      passportType,
      pms1,
      pms10000,
      groupId,
      barId,
      smsCode,
    },
  });
};
// 修改
export const Edit = ({
  name,
  passportName,
  passportState,
  password,
  phone,
  email,
  pms1,
  pms10000,
  groupId,
  barId,
  smsCode,
}) => {
  return http.post({
    url: httpApi.emplyee.edit,
    data: {
      name,
      passportName,
      passportState,
      password,
      phone,
      email,
      pms1,
      pms10000,
      groupId,
      barId,
      smsCode,
    },
  });
};

// 查询网吧分组列表
export const _searchGroupName = ({ groupName }) => {
  return http.usualPost({
    url: httpApi.emplyee.getSearchGroupNameList,
    data: {
      groupName,
    },
  });
};
// 查询网吧列表列表
export const _searchBarName = ({ barName }) => {
  return http.usualPost({
    url: httpApi.emplyee.getSearchBarNameList,
    data: {
      barName,
    },
  });
};
// 获取短信
export const getsmscode = () => {
  return http.post({
    url: httpApi.emplyee.getsmscode,
  });
};
export const switchSafeCenter = (data) => {
  return http.post({
    url: httpApi.emplyee.switchSafeCenter,
    data: data,
  });
};
export const switchDllFlag = (data) => {
  return http.post({
    url: httpApi.emplyee.switchDllFlag,
    data: data,
  });
};
